import { render } from "./SprinklrApiWebhooks.vue?vue&type=template&id=a9510ec2&scoped=true&ts=true"
import script from "./SprinklrApiWebhooks.vue?vue&type=script&lang=ts"
export * from "./SprinklrApiWebhooks.vue?vue&type=script&lang=ts"

import "./SprinklrApiWebhooks.vue?vue&type=style&index=0&id=a9510ec2&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9510ec2"]])

export default __exports__